export default function scrollToTop(element, data) {
    const observer = new IntersectionObserver(addClass, {threshold: 0.2});

    let imagesBlocks = element.querySelectorAll('.advantages__item_images');

    imagesBlocks.forEach(block => {
        observer.observe(block);
    });

    function addClass(entries, observer) {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('animate');
                observer.unobserve(entry.target);
            }
        });
    }
};
